import React, {FC} from "react";
import {getPageNameByPageId, getSystemLanguageId, getUserId} from "../../../utils";
import {ReportItemsSearchPanel, ReportPage} from "../../../components";
import {ItemReportSearchParamsModel, PageEnum} from "../../../models";
import {searchReportSummeryItemTransactionQuantity} from "../../../serviceBroker/itemsReportApiServiceBroker";

export const ReportSummeryItemTransactionQuantityPage: FC = () => {
    const initialState: ItemReportSearchParamsModel = {Lang: getSystemLanguageId(), userId: getUserId()};
    return (
        <ReportPage
            InitialState={initialState}
            SearchApi={searchReportSummeryItemTransactionQuantity}
            searchHeader={getPageNameByPageId(PageEnum.ReportItemWithQuantity)}
            SearchPanel={ReportItemsSearchPanel}
            formId={PageEnum.ReportItemWithQuantity}
        />
    );
};
